<template>
  <!-- Page Content -->
  <div id="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <h1 class="page-header"><i class="fa fa-book fa-fw"></i>Regras Documentais</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class="row">
        <div class="pull-right">
          <a
            class="btn btn-default"
            @click="addButton.seeForm = !addButton.seeForm; rule = {}"
          >
            <span v-if="addButton.seeForm">
              <i class="fa fa-search fa-fw"></i>Buscar
            </span>
            <span v-else> <i class="fa fa-plus fa-fw"></i> Adicionar </span>
          </a>
          <br />
          <br />
          <br />
        </div>

        <div class="col-lg-12">
          <form
            v-if="addButton.seeForm"
            role="form"
            @submit.stop.prevent="send"
          >
            <input v-model="rule.id" type="hidden" />
            <div class="form-group">
              <label>Nome</label>
              <input v-model="rule.name" class="form-control" />
            </div>
            <div class="form-group">
              <label>Descricao</label>
              <input v-model="rule.description" class="form-control" />
            </div>
            <button type="submit" class="btn btn-block btn-info">Salvar</button>
          </form>
          <form v-else>
            <div class="form-group">
              <input
                v-model="search"
                class="form-control"
                placeholder="Buscar..."
              />
            </div>
          </form>
        </div>
      </div>
      <hr />
      <div class="row">
        <div v-if="filtred.length">
          <div
            class="col-lg-4"
            v-for="rule in filtred"
            :key="rule.id"
          >
            <div class="panel panel-default">
              <div class="panel-heading">
                #{{ rule.id }} <b>{{ rule.name.substring(0, 19) }}</b>
                <div class="pull-right">
                  <div class="btn-group" role="group">
                    <a
                      @click.stop="edit(rule.id)"
                      class="btn btn-sm btn-primary"
                      ><i class="fa fa-pencil fa-fw"></i
                    ></a>
                    <a
                      @click.stop="remove(rule.id)"
                      class="btn btn-sm btn-danger"
                      ><i class="fa fa-trash fa-fw"></i
                    ></a>
                  </div>
                  <br />
                </div>
                <br />
              </div>
              <div class="panel-body">
                <p>
                 {{rule.description}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="alert alert-info">
            <p><i class="fa fa-exclamation fa-fw"></i>Nenhum registro foi encontrado</p>
          </div>
        </div>
      </div>
    </div>
    <!-- /.container-fluid -->
  </div>
</template>

<script>
export default {
  name: "Rules",
  data() {
    return {
      search: "",
      addButton: { seeForm: false },
      rule: {},
      rules: [],
    };
  },
  mounted() {
    this.$http.get("rule").then((response) => {
      this.rules = response.data;
    });
  },
  methods: {
    send() {
      if (this.rule.id) {
        this.$http
          .put(`/rule/${this.rule.id}`, this.rule)
          .then((response) => {
            this.rules = this.rules.filter(
              (item) => item.id != this.rule.id
            );
            this.rules.push(response.data);
            this.rule = {};
            this.addButton.seeForm = false;
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$http
          .post("/rule", this.rule)
          .then((response) => {
            this.rule = {};
            this.rules.push(response.data);
            this.addButton.seeForm = false;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    edit(id) {
      this.$http
        .get(`/rule/${id}`)
        .then((response) => {
          this.addButton.seeForm = true;
          this.rule = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    remove(id) {
      const yes = confirm("Realmente deseja remover esse registro");

      if (yes) {
        this.$http
          .delete(`/rule/${id}`)
          .then((response) => {
            this.rules = this.rules.filter((item) => item.id != id);
          })
          .catch((error) => alert(error));
      }
    },
  },
  computed: {
    filtred() {
      const search = this.search.toLowerCase().trim();

      if (!search) {
        return this.rules;
      }

      return this.rules.filter(
        rule => rule.name.toLowerCase().indexOf(search) > -1
      );
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/Rules.vue